import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import ReceivingMap from './ReceivingMap';
import PhoneInput from "react-phone-number-input";
import { useForm } from "../context/FormContext";

const myStyle = {
    background: '#6EA3D5',
    padding: '8px',
    borderRadius: '5px',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center'
};

const PageTitle = () => <Typography
    variant='h6'
    style={myStyle}
    fontWeight={"bold"} >
    Receiver Details
</Typography>

const ReceiverDetails = ({ type }) => {
    const { formData, errors, updateField } = useForm();

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <PageTitle />
                {type !== 'pp_to_door' && type !== 'kiosk_to_door' && (<ReceivingMap type={type} />)}
                <TextField
                    required
                    id="receiver_name"
                    label="Receiver Name"
                    value={formData.receiverName || ""}
                    onChange={(e) => updateField("receiverName", e.target.value)}
                />
                <PhoneInput
                    required
                    placeholder="Enter phone number"
                    value={formData.receiverNumber || ""}
                    onChange={(value) => updateField("receiverNumber", value)}
                    countryCallingCodeEditable={false}
                    international
                    defaultCountry="ZA"
                    error={errors.receiverNumber}
                    className={errors.receiverNumber ? "phone-input-error" : ""}
                    style={{
                        border: errors.receiverNumber ? '1px solid red' : ''
                    }}
                />
                {errors?.receiverNumber && <div style={{ color: "red",marginBottom:'3px'}} className="HelperText">{errors?.receiverNumber}</div>}

                <TextField
                    id="receiver_email"
                    label="Receiver Email"
                    value={formData.receiverEmail || ""}
                    onChange={(e) => updateField("receiverEmail", e.target.value)}
                    error={errors.receiverEmail}
                    helperText={errors.receiverEmail}
                    fullWidth
                    required
                />
            </Box>
        </React.Fragment>
    );
}

export default ReceiverDetails;